import { type PhoneNumberInput } from '@egw/api'

export enum ChannelType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
}

export interface RecoveryFlow {
  channel: ChannelType | null
  email?: string
  phone?: PhoneNumberInput
  documentVerificationUrl?: string
  documentVerificationToken?: string
  documentVerificationBaseUrl?: string
  verificationId?: string
  verificationToken?: string
  isPhoneVerified: boolean
  isEmailVerified: boolean
}

export enum CameraPermissionState {
  GRANTED = 'granted',
  DENIED = 'denied',
  PROMPT = 'prompt',
  UNKNOWN = 'unknown',
}
